import type { Maybe } from '@adornis/base/utilTypes.js';

function slugify(s?: string): string | undefined {
  if (!s) return undefined;
  return s
    .toString()
    .trim()
    .toLowerCase()
    .normalize('NFKD')
    .replace(/\p{Diacritic}+/gu, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function parseSkillList(value?: Maybe<string>): string[] {
  if (!value) return [];
  const parts = value
    .split(/[;\,\n]/g)
    .map(s => s.trim())
    .filter(Boolean)
    .map(s => slugify(s.replace(/\(.*?\)/g, ''))!)
    .filter(Boolean);
  return Array.from(new Set(parts));
}
